import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-awesome-bookmark",
  "use": "icon-awesome-bookmark-usage",
  "viewBox": "0 0 12 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 16\" id=\"icon-awesome-bookmark\"><defs><style>#icon-awesome-bookmark .a{fill:#fff;}</style></defs><path class=\"a\" d=\"M0,16V1.5A1.5,1.5,0,0,1,1.5,0h9A1.5,1.5,0,0,1,12,1.5V16L6,12.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol